import {ReactNode} from 'react';

import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

import {ItemClChildrenItemType} from './upsellsType';

type ReducerType = {
    status: string;
    popupContent: ItemClChildrenItemType | ReactNode;
};

export const initialState: ReducerType = {
    popupContent: {
        contactLensColors: [{id: 0, label: ''}],
        contactLensPerBox: 0,
        contactLensTypeLabel: '',
        media: {
            front: {
                file: '',
            },
        },
    },
    status: '',
};

/**
 * Add upsell item
 * @param {number} id  quote item id
 * @param {string} name upsale alias
 * @returns {ActionType<AxiosPromise>} Action
 */
export const addUpsellItemAction = createAsyncThunk<void, {id: string; name: string}>(
    'CART@ADD_UPSELL_ITEM',
    ({id, name}) =>
        apiConfig.instanceGusaBackend({
            method: 'get',
            url: `${ENDPOINTS.CART_ADD_UPSELL}/?option=${name}&item_id=${id}`,
        }),
);

/**
 * Remove upsell item
 * @param {number} id  quote item id
 * @param {string} name upsale alias
 * @returns {ActionType<AxiosPromise>} Action
 */
export const removeUpsellItemAction = createAsyncThunk<void, {id: string; name: string}>(
    'CART@REMOVE_UPSELL_ITEM',
    ({id, name}) =>
        apiConfig.instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            method: 'get',
            url: `${ENDPOINTS.CART_REMOVE_UPSELL}/?option=${name}&item_id=${id}`,
        }),
);

/**
 * Set popup content
 * @param {ReactNode} content - popup content
 * @return {ActionType<ReactNode>} Action
 */
export const setUpsellPopupContent = createAction<ReactNode>('CART@UPSELL_POPUP_CONTENT');

/**
 * Cart upsells reducer
 * @param {ReducerType} state - reducer state
 * @return {ReducerType} reducer state
 */
export const cartUpsells = createReducer(initialState, builder =>
    builder
        .addCase(addUpsellItemAction.pending, state => ({...state, status: 'pending'}))
        .addCase(addUpsellItemAction.fulfilled, state => ({...state, status: 'fulfilled'}))
        .addCase(removeUpsellItemAction.pending, state => ({...state, status: 'pending'}))
        .addCase(removeUpsellItemAction.fulfilled, state => ({...state, status: 'fulfilled'}))
        .addCase(setUpsellPopupContent, (state, action) => ({
            ...state,
            popupContent: action.payload,
        })),
);
